import { useState } from "react";
import { ImageOff } from "lucide-react";

interface ImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

const ImageFallback = ({ src, alt, className }: ImageProps) => {
  const [hasError, setHasError] = useState(false);

  if (hasError || !src) {
    return (
      <div
        className={`flex items-center justify-center bg-slate-800 text-slate-500 ${className}`}
      >
        <ImageOff className="h-8 w-8 opacity-60" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setHasError(true)}
    />
  );
};

export default ImageFallback;
